import { RGRLesson, RGRGrade, RGRSkill } from './rgr-lessons';
import { BRITANNICA_PUBLISHER } from './britannica-publisher';
import { NEARPOD_PUBLISHER } from './nearpod-publisher';

const GRADE_ORDINAL: Record<string, RGRGrade> = {
  '0': 'K', '1': '1st', '2': '2nd', '3': '3rd',
  '4': '4th', '5': '5th', '6': '6th', '7': '7th', '8': '8th',
};

function parseGradeBand(grade: string): { primary: RGRGrade; all: RGRGrade[] } {
  if (grade === 'Kindergarten') return { primary: 'K', all: ['K'] };

  // "Grade 1", "Grade 5", etc.
  const single = grade.match(/^Grade\s+(\d)$/);
  if (single) {
    const g = GRADE_ORDINAL[single[1]] ?? '1st';
    return { primary: g, all: [g] };
  }

  // "Grades K–1", "Grades 3–5", etc. (en-dash or hyphen)
  const range = grade.match(/^Grades?\s+([K\d])[–\-](\d)$/);
  if (range) {
    const startNum = range[1] === 'K' ? 0 : parseInt(range[1]);
    const endNum = parseInt(range[2]);
    const all: RGRGrade[] = [];
    for (let i = startNum; i <= endNum; i++) {
      all.push(GRADE_ORDINAL[String(i)] ?? 'K');
    }
    return { primary: all[0], all };
  }

  return { primary: 'K', all: ['K'] };
}

export const BRITANNICA_GALLERY_LESSONS: RGRLesson[] = BRITANNICA_PUBLISHER.lessons.map((l) => {
  const { primary, all } = parseGradeBand(l.grade);
  return {
    brand: 'Pressto',
    program: 'Britannica Learning',
    unit: l.britannicaTitle,
    skill: l.area as RGRSkill,
    grade: primary,
    grades: all.length > 1 ? all : undefined,
    gradeBand: l.grade,
    title: l.title,
    status: l.templateUrl ? 'live' : 'coming-soon',
    templateUrl: l.templateUrl || undefined,
    source: 'pressto-authored',
  };
});

export const NEARPOD_GALLERY_LESSONS: RGRLesson[] = NEARPOD_PUBLISHER.lessons.map((l) => {
  const { primary, all } = parseGradeBand(l.grade);
  // Strip grade suffix from nearpodTitle: "Personification: 2-3" → "Personification"
  const unitLabel = l.nearpodTitle.replace(/:\s*[\dK][\d\-–]*\s*$/, '').trim();
  return {
    brand: 'Pressto',
    program: 'Nearpod',
    unit: unitLabel,
    skill: l.area as RGRSkill,
    grade: primary,
    grades: all.length > 1 ? all : undefined,
    gradeBand: l.grade,
    title: l.title,
    status: l.templateUrl ? 'live' : 'coming-soon',
    templateUrl: l.templateUrl || undefined,
    source: 'pressto-authored',
  };
});
